import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Store} from '@ngxs/store';
import {firstValueFrom, Observable} from 'rxjs';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {Loader} from '../../models/loader/loader.redux';
import {IPatient, PatientAction, PatientState} from '../../models/patient';
import {cloneDeep} from 'lodash';
import {IPaginatorConfiguration} from '../paginator/paginator.component';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {ModalCreatePatientComponent} from '../modal-create-patient/modal-create-patient.component';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {IUser} from '../../models/auth';
import {Logger} from '../../class/helper/logger.class';
import {ClinicActions} from '../../models/clinic';
import {AnyObject} from '../../interfaces/utils';


@Component({
  selector: 'app-modal-add-patient-appointment',
  templateUrl: './modal-add-patient-appointment.component.html',
  styleUrls: ['./modal-add-patient-appointment.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalAddPatientAppointmentComponent implements OnInit {
  // tslint:disable:no-redundant-jsdoc
  @Input() isVisibleModal: boolean;
  @Input() clinicId: string;
  @Input() patientId: string;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  assistants$: Observable<IPatient[]> = this.store.select<IPatient[]>(PatientState.getAssistants);
  total$: Observable<number> = this.store.select<number>(PatientState.getAssistantsCount);
  @ViewChild(ModalCreatePatientComponent)
  modalCreatePatientComponent: ModalCreatePatientComponent;
  // tslint:disable:variable-name
  selectedAssistants: string[] = [];
  selectedUsersAppointment: IPatient[] = [];
  _selectedAssistantsAux: string[] = [];
  _selectedUsersAppointmentAux: IPatient[] = [];

  disableAddPatients: boolean;

  search: string;
  actualInterval: any;
  // paginador
  paginatorConfig: IPaginatorConfiguration;
  indexPage: number;
  showModalAddPatient: boolean;

  constructor(
    private store: Store,
    private utilitiesServices: UtilitiesService,
    private messageAlertService: MessageAlertService,

  ) { }

  ngOnInit(): void {
    this.search = '';
    this.disableAddPatients = true;
    this.indexPage = 1;
    this.paginatorConfig = {
      nzPageSize: 10
    };
    this.showModalAddPatient = false;

  }

  onSelectAssistant(patient: IPatient | any): void {
    // -- Limitar sólo a 1 asistente
    if (!patient) return;
    this.selectedAssistants = [patient._id];
    this.selectedUsersAppointment = [patient];
    this.disableAddPatients = false;
  }

  onCloseModal(emit: boolean): void {
    if (!emit) {
      // Restablecer cambios en modal
      this.selectedAssistants = cloneDeep(this._selectedAssistantsAux);
      this.selectedUsersAppointment = cloneDeep(this._selectedUsersAppointmentAux);
    } else {
      this._selectedAssistantsAux = cloneDeep(this.selectedAssistants);
      this._selectedUsersAppointmentAux = cloneDeep(this.selectedUsersAppointment);
    }
    this.search = '';
    this.disableAddPatients = true;
    this.closeModal.emit(emit);
  }

  async onSearch($event): Promise<void> {
    if (this.actualInterval !== null) {
      clearInterval(this.actualInterval);
    }
    this.actualInterval = setTimeout(async () => {
      if (this.search !== $event.target.value) {
        this.search = $event.target.value;
        await firstValueFrom((this.store.dispatch(new Loader(true))));
        await this.getCountPatients();
        await firstValueFrom((this.store.dispatch(new ClinicActions.GetPatientAssistants(this.clinicId, this.search))));
        await firstValueFrom((this.store.dispatch(new Loader(false))));
      }
    }, 400);
  }

  /**
   * Cambia el indice de la paginación.
   * @param index
   */
  async onChangePagination(index: number): Promise<void> {
    await firstValueFrom((this.store.dispatch(new Loader(true))));
    this.indexPage = index;
    await this.getData();
    await firstValueFrom((this.store.dispatch(new Loader(false))));
  }

  /**
   * Obtiene los datos desde el servidor.
   * @param withCount
   */
  async getData(withCount: boolean = false): Promise<void> {
    if (withCount) {
      await this.getCountPatients();
    }
    const filter = this.utilitiesServices.filterCountPagination(this.indexPage, this.paginatorConfig.nzPageSize);
    await firstValueFrom((this.store.dispatch(new ClinicActions.GetPatientAssistants(this.clinicId, this.search, filter))));
  }

  /**
   * Obtiene el número total de elementos para la tabla.
   */
  async getCountPatients(): Promise<void> {
    await firstValueFrom((this.store.dispatch(new PatientAction.CountByClinicId(this.clinicId, this.search, ''))));
  }

  async onCloseModalAddPatient(action: boolean): Promise<void> {
    if (!action) {
      this.showModalAddPatient = false;
      return;
    }

    // Checando formulario con observaciones
    this.modalCreatePatientComponent.formMarkAllAsTouched();
    if (!this.modalCreatePatientComponent.areValidForms()) {
      this.messageAlertService.createMessage('error', this.messageAlertService.messages.incompleteData);
      return;
    }
    await firstValueFrom((this.store.dispatch(new Loader(true, 'Guardando datos ...'))));
    try {
      const patient = cloneDeep(this.modalCreatePatientComponent?.patient);
      if (!patient) {
        this.messageAlertService.createMessage(
          'error',
          'Ha ocurrido un error, por favor intente más tarde.'
        );
      }
      const modalData = this.modalCreatePatientComponent.getValue();
      const user: IUser = patient.user;
      user.password = '123asdZXC';
      user.address = modalData.address;
      user.phones = modalData.phones;
      await firstValueFrom((this.store.dispatch(new PatientAction.Post(this.clinicId, user))));
      this.messageAlertService.createMessage('success', '¡Paciente creado con éxito!', 5000);
      this.modalCreatePatientComponent.resetForms();
      this.showModalAddPatient = false;

      const patientCreated: IPatient = cloneDeep(await firstValueFrom((this.store.selectOnce(PatientState.getPatientCreated))));
      // Obtengo un partial de los datos del paciente
      if (patientCreated) {
        const postPatient: AnyObject = {
          _id: patientCreated._id,
          folioNumber: patientCreated.folioNumber,
          patientCreated: patientCreated.createdAt,
          userId: patientCreated.user._id,
          fullName: patientCreated.user.name + patientCreated.user.lastname,
          email: patientCreated.user.email,
          gender: patientCreated.user.gender,
          profileImageURL: patientCreated.user.profileImageURL,
          birthday: patientCreated.user.birthday,
          timeZone: patientCreated.user.timeZone,
        };
        // Se agrega el paciente a la lista de asistentes
        await firstValueFrom(this.store.dispatch(new PatientAction.AddAssistantToList(postPatient)));
        this.onSelectAssistant(postPatient);
      }
    } catch (e) {
      Logger.log('Ocurrió un error', e?.message);
      let messageError = '';
      if (e.message === 'The user has already been registered previously') {
        messageError = 'El usuario ya se ha registrado previamente';
      }
      this.messageAlertService.createMessage(
        'error',
        messageError
          ? messageError
          : this.messageAlertService.getMessageError(e.message)
      );
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }
}
